import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import '../../Placement.css';
import bannerImage from "../../Images/Banner/university.webp";
import classroomImage from "../../Images/placement/placement1.webp";
import img2 from '../../Images/placement/placement3.webp';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import company1 from "../../Images/companylogo2/Gujarat Ambuja Exports Limited 2.webp";
import company2 from "../../Images/companylogo2/aquaplast.webp";
import company3 from "../../Images/companylogo2/aurobindo.webp";
import company4 from "../../Images/companylogo2/dabur.webp";
import company5 from "../../Images/companylogo2/hira-logo1.webp";
import company6 from "../../Images/companylogo2/kalpataru.webp";
import company7 from "../../Images/companylogo2/nsdc.webp";
import company8 from "../../Images/companylogo2/securitylab.webp";
import company9 from "../../Images/companylogo2/tmc.webp";
import company10 from "../../Images/companylogo2/vrize.webp";
import company11 from "../../Images/companylogo2/apb_company.jfif";
import company12 from "../../Images/companylogo2/bsa_corporation_limited_company.jfif";
import company13 from "../../Images/companylogo2/chemfield_cellulose_logo.jfif";
import company14 from "../../Images/companylogo2/dbpower.jfif";
import company15 from "../../Images/companylogo2/digiSafari_company2.jfif";
import company16 from "../../Images/companylogo2/nitika.jfif";
import company17 from "../../Images/companylogo2/Struc_sompany4.jfif";
import company18 from "../../Images/companylogo2/tuliplab_logo.jfif";

class Placements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
            activeIndex: 0,
        };
    }

    jobTitles = [
        "Training & Placement Database",
        "Resume Preparation",
        "Career & Employability Assessment"
    ];

    marketingData = [
        {
            title: "Pre-Placement Training:",
            content:
                "Resume preparation sessions, aptitude tests, soft skills enhancement, and grooming workshops to prepare students for recruitment.",
            dark: true,
        },
        {
            title: "Company Onboarding:",
            content:
                "Facilitating employer registrations and sharing detailed job profiles with eligible students for transparency and preparation.",
            dark: false,
        },
        {
            title: "Student Registration:",
            content:
                "Verification of student eligibility and smooth application handling through a streamlined registration process.",
            dark: true,
        },
        {
            title: "Recruitment Drives:",
            content:
                "Organizing and managing on-campus or virtual selection drives with logistical and technical coordination.",
            dark: false,
        },
        {
            title: "Final Selection:",
            content:
                "Coordination of final interviews, assessments, and issuing of offer letters to successful candidates.",
            dark: true,
        },
        {
            title: "Post-Placement Support:",
            content:
                "Providing HR onboarding assistance, alumni engagement, and feedback mechanisms for continuous improvement.",
            dark: false,
        }
    ];

    highlights = [
        {
            title: 'Centre for Higher Studies',
            text: 'Fosters a network among universities, institutions abroad and imparts higher education and collaborative study programs to prepare the students for the exams like GATE, GRE, CAT, GMAT & UPSC.',
        },
        {
            title: 'Centre for Entrepreneurship',
            text: 'Facilitates the students in bringing out innovation and empowers them to start their own ventures. It also support students to participate in government sponsored skill development projects.',
        },
    ];

    features = [
        {
            title: "Abhishek Sahu",
            text: "Balco",
            location: "Jharkhand"
        },
        {
            title: "Abhishek Singh",
            text: "Hindalco industries Ltd",
            location: "Raigarh"
        },
        {
            title: "Soumodip Mukhopadhyay",
            text: "GSMPL",
            location: "Durgapur"
        },
        {
            title: "Amrit Kumar Lakra",
            text: "TMC Technoblast Mining Corporation",
            location: "Jharkhand"
        },
        {
            title: "Arun Kumar Gupta",
            text: "Jindal Power Ltd",
            location: "Chhattisgarh"
        },
        {
            title: "Basant Patel",
            text: "Ambuja Cements Limited",
            location: "Chhattisgarh"
        },
        {
            title: "Umakant Chaudhary",
            text: "Nuvoco Vistas Corporate Limited",
            location: "Baloda Bazar (Cg)"
        },
        {
            title: "Vickrant Kumar",
            text: "Dilip Buildcon Limited",
            location: "Durgapur"
        },
        {
            title: "Rajbihari Sahu",
            text: "BGR Limited",
            location: "Bargarh"
        },
        {
            title: "Pritam Sarkar",
            text: "Gainwell Commosales Pvt Ltd",
            location: "Asansol"
        },
        {
            title: "Shyam Narayan Rathour",
            text: "TMC",
            location: "Raigarh"
        },
        {
            title: "Shubham Rajendra Kamadwar",
            text: "Sunflag Iron and Steel Coal India Limited",
            location: "Chandarpur"
        }
    ];

    recruiters = [
        { name: "Gujarat Ambuja Exports Limited", logo: company1 },
        { name: "Aquaplast", logo: company2 },
        { name: "Aurobindo Pharma", logo: company3 },
        { name: "Dabur", logo: company4 },
        { name: "HIRA Group", logo: company5 },
        { name: "Kalpataru Power Transmission Ltd.", logo: company6 },
        { name: "NSDC (National Skill Development Corporation)", logo: company7 },
        { name: "Security Lab", logo: company8 },
        { name: "TMC (The Mandhana Consortium)", logo: company9 },
        { name: "Vrize", logo: company10 },
        { name: "APB Corporation", logo: company11 },
        { name: "BSA Corporation Limited", logo: company12 },
        { name: "Chemfield Cellulose", logo: company13 },
        { name: "DB Power", logo: company14 },
        { name: "DigiSafari", logo: company15 },
        { name: "Nitika Pharmaceuticals", logo: company16 },
        { name: "STRUC (Structural Solutions Company)", logo: company17 },
        { name: "Tulip Lab", logo: company18 },
    ];

    placementStats = [
        { value: "₹45", unit: "LPA", label: "Highest Package Offered" },
        { value: "₹25", unit: "LPA", label: "Average Package" },
        { value: "6+", unit: "", label: "Top Sectors" },
    ];

    setActiveIndex = (index) => {
        this.setState({ activeIndex: index });
    };

    render() {
        const sliderSettings = {
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        const recruiterSettings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        };
        return (
            <>
                <title>ISBM University Placements | Career Opportunities & Industry Connections</title>
                <meta
                    name="description"
                    content="ISBM University Placement Cell connects students with top recruiters and career guidance. Start your successful career—explore placements today."
                />
                <Topnav />
                {/* Banner */}
                <section className="section-hero-banner ptb-50" style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}>
                    <div className="banner-hero-overlay">
                        <div className="container-xxl">
                            <div className="section-hero-content">
                                <h1>Placement Excellence</h1>
                                <ol className="breadcrumb mt-3 text-center mb-0">
                                    <li className="breadcrumb-item">
                                        <a href="/" style={{ color: "#fff", textDecoration: "none" }}>Home</a>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">
                                        Placement
                                    </li>
                                    <hr className="section-divider" />
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Training */}
                <section className="container-xxl ptb-50">
                    <Row className="flex-wrap-reverse">
                        {/* Job List Section */}
                        <div className="col-md-6 d-flex justify-content-center">
                            <div className="students-gallery-section">
                                <div className="gallery-grid">
                                    <div className="background-block"></div>

                                    <div className="gallery-item large">
                                        <img src={img2} alt="ISBM University Training & Placement Cell group photo" />
                                    </div>

                                    {/* <Row className="row m-0">
                                        <div className="gallery-item small col-6">
                                            <img src={img2} alt="Group 2" />
                                        </div>
                                        <div className="gallery-item small col-6">
                                            <img src={img3} alt="Group 3" />
                                        </div>
                                    </Row> */}
                                </div>
                            </div>
                        </div>
                        <Col md={6}>
                            <div className="row align-items-center">
                                {/* Left Column - Text */}
                                <div className="p-4">
                                    <h2 className="modern-title text-blue">
                                        Training & Placement Cell
                                    </h2>
                                    <div className="underline-divider mb-3"></div>
                                    <p>
                                        The Training and Placement Cell of ISBM University, Chhattisgarh, is a dynamic link between students and the corporate world.
                                        Our mission is to groom students for successful careers by enhancing their industry-oriented skills, creating corporate
                                        alliances, and ensuring significant placement opportunities.
                                    </p>
                                    <p>
                                        We partner with leading recruiters of various industries to offer job placements, internships, corporate training, and
                                        career counseling that enable students to succeed in the competitive world of today.
                                    </p>
                                </div>
                            </div>
                            <div className="stats-container">
                                <div className="stats-grid">
                                    {this.placementStats.map((stat, index) => (
                                        <div
                                            className="stat-card shadow"
                                            key={index}
                                            data-aos="fade-up"
                                            data-aos-delay={index * 100}
                                        >
                                            <div className="stat-value">
                                                {stat.value}
                                                {stat.unit && (
                                                    <span className="lpa-text"> {stat.unit}</span>
                                                )}
                                            </div>
                                            <div className="stat-label">{stat.label}</div>
                                            <div className="stat-decoration"></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row >
                </section >

                {/* Vision */}
                <section className="container-xxl py-5">
                    <div className="row mx-0 mt-4">
                        {/* Left Column */}
                        <div className="col-lg-6 col-12 mb-4 mb-lg-0">
                            <div className="coCol1 h-100">
                                <figure>
                                    <h2 className="black_title">Vision:</h2>
                                </figure>
                                <p>
                                    To be a catalyst for empowering students with the skills, opportunities, and exposure required to
                                    transform them into globally competent professionals, entrepreneurs, and responsible citizens.
                                </p>
                            </div>
                        </div>
                        {/* Right Column */}
                        <div className="col-lg-6 col-12">
                            <div className="coCol1 h-100">
                                <figure>
                                    <h2 className="black_title">Mission:</h2>
                                </figure>
                                <p>
                                    To bridge the gap between academia and industry by building strong corporate relations,
                                    facilitating skill-based training, and empowering students with the knowledge, competencies,
                                    and confidence required to excel in their professional careers and meet the evolving demands of the global job market.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* testimonials */}
                <section className="students ptb-50 justify-content-between">
                    <div className="container-xxl">
                        <Slider {...sliderSettings}>
                            {this.features.map((feature, idx) => (
                                <div key={idx} className="px-3">
                                    <div className="feature-box shadow-sm p-4 rounded border text-center h-100">
                                        <h5 className="fw-bold mb-3">{feature.title}</h5>
                                        <p className="mb-0">{feature.text}</p>
                                        <p>{feature.location}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </section>

                {/* Objectives */}
                <section className="container-xxl justify-content-between">
                    <Row className="mt-5">
                        {/* Right Column - Image */}
                        <div className="col-md-6 p-4">
                            <h2 className="modern-title text-blue">
                                Objectives of the Training and Placement Cell
                            </h2>
                            <div className="underline-divider mb-3"></div>
                            <ul>
                                <li>Organize campus recruitment drives in various fields</li>
                                <li>Arrange for career guidance and aptitude training sessions</li>
                                <li>Arrange internships, live projects, and on-the-job training</li>
                                <li>Organize soft skills and personality development programs</li>
                                <li>Establish strategic industry relationships and connect with HR leaders</li>
                                <li>Promote entrepreneurial spirit and leadership development</li>
                                <li>Have an active alumni and recruiter network</li>
                            </ul>
                        </div>
                        <div className="col-md-6 mt-5 d-flex justify-content-center">
                            <div className="image-wrapper position-relative">
                                <div className="image-bg"></div>
                                <img
                                    src={classroomImage}
                                    className="img-fluid rounded placement-image position-relative"
                                    alt="ISBM University Training & Placement Cell team"
                                />
                            </div>
                        </div>
                    </Row>
                </section >

                <section className="ptb-50 bg-new">
                    <div className="container-xxl">
                        <Row className="mt-5">
                            <Col lg={12}>
                                <div className="recruiters-section" data-aos="fade-up">
                                    <h2 className="modern-title">Our Top <span>Recruiters</span></h2>
                                    <p className="modern-subtitle">
                                        We partner with industry leaders to provide exceptional
                                        opportunities
                                    </p>

                                    <Slider {...recruiterSettings} className="recruiters-slider">
                                        {this.recruiters.map((recruiter, index) => (
                                            <div className="recruiter-item" key={index}>
                                                <div className="recruiter-logo-container">
                                                    <img
                                                        src={recruiter.logo}
                                                        alt={recruiter.name}
                                                        className="recruiter-logo"
                                                    />
                                                </div>
                                                <p className="recruiter-name">{recruiter.name}</p>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                {/* Lifecycle */}
                <section className="container-xxl ptb-50" >
                    <h2 className="modern-title text-blue text-center">
                        Campus Recruitment Lifecycle
                    </h2>
                    <div className="underline-center mb-3"></div>
                    <Row className="m-0">
                        <Col md={6}>
                            <Row className="g-4">
                                {this.marketingData.slice(0, 3).map((item, index) => (
                                    <Col key={index} md={12}>
                                        <Card
                                            className={`ups-card p-4 h-100 ${item.dark ? '' : 'border'}`}
                                        >
                                            <Card.Title className="fw-bold">
                                                {item.title}
                                            </Card.Title>
                                            <Card.Text className="text-black">{item.content}</Card.Text>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row className="g-4">
                                {this.marketingData.slice(3).map((item, index) => (
                                    <Col key={index} md={12}>
                                        <Card
                                            className={`ups-card p-4 h-100 ${item.dark ? '' : 'border'}`}
                                        >
                                            <Card.Title className="fw-bold">
                                                {item.title}
                                            </Card.Title>
                                            <Card.Text className="text-black">{item.content}</Card.Text>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </section >

                {/* <section className="ptb-50 justify-content-between highlights">
                    <div className="container-xxl">
                        <Row className="mt-3">
                            {this.highlights.map((item, index) => (
                                <Col md={6} lg={6} className="mb-3" key={index}>
                                    <div className="highlight-card d-flex">
                                        <div className="highlight-content">
                                            <h4>{item.title}</h4>
                                            <div className="underline-divider mb-3"></div>
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </section> */}

                {/* <section className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-5 mt-5 d-flex justify-content-center position-relative">
                            <div className="image-bg1"></div>
                            <img
                                src={faqImage}
                                alt="JNU Campus"
                                className="img-fluid rounded placement-image"
                            />
                        </div>
                        <div className="col-1"></div>
                        <div className="col-md-6 mt-5">
                            <h2 className="fw-bold text-dark">Employability Enhancement Program</h2>
                            <div className="underline-divider"></div>
                            <p>
                                We aim to give our students the fine-tuning that they require not just for placements
                                but also as they embark on their corporate careers.
                            </p>
                            <div className="faq-bg-box"></div>
                            <p>
                                Training & Placement Office Follows a four year training modules divided in foundation, intermediate , and advanced skills off trending technologies. With this goal in mind, we carry out several employability enhancement activities that include :
                            </p>
                        </div>
                    </Row>
                </section> */}

                {/* <section className="points ptb-50 justify-content-between">
                    <div className="container-xxl">
                        <Slider {...sliderSettings}>
                            {this.points.map((point, idx) => (
                                <div key={idx} className="px-3">
                                    <div className="feature-box shadow-sm p-4 rounded border text-center h-100">
                                        <h5 className="fw-bold mb-3 point">{point.points}</h5>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </section> */}


                <Footer />
            </>
        );
    }
}

export default Placements;

